export const DATA_POLICY_LINK = 'https://luchi.ru/legal/data-policy/';
